import { appendClassName } from '@componentLibraryWrapper/common';
import { Grid, GridProps } from '@componentLibraryWrapper/grid';
import './gridContainer.scss';

export interface GridContainerProps extends Omit<GridProps, 'xl' | 'lg' | 'md' | 'sm' | 'xs'> {
}

const GridContainer = ({
	className,
	spacing=0,
	...rest
}: GridContainerProps) => {
	return (
		<Grid
			{...rest}
			className={appendClassName('sm-gridcontainer', className)}
			spacing={spacing}
			container>
		</Grid>
	)
}

export default GridContainer;